import React, { useState } from "react";
import { Link } from "react-router-dom";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import { all_routes } from "../router/all_routes";
import Table from "../../core/common/dataTable";
import useApi from "../../core/customhook/useApi";
import Loader from "../../core/common/selfLoder";

interface Engagement {
  activity_name: string;
  activity_fromdate: string;
  activity_todate: string;
  activity_category: string;
  activity_type: string;
}

interface EngagementMainResponse {
  success: boolean;
  message: string;
  statusCode: number;
  data: Engagement[];
}

const EngagementCalender: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>("");

  const tabs = [
    { key: "", label: "All Activities" },
    { key: "EA", label: "Engagement Activity" },
    { key: "ES", label: "Expert Session" },
  ];

  const safeSort = (a: Engagement, b: Engagement, key: keyof Engagement) => {
    if (!a[key]) return -1;
    if (!b[key]) return 1;
    return a[key]!.toString().localeCompare(b[key]!.toString());
  };

  const getMonth = (date: string) =>
    new Date(date).toLocaleString("default", { month: "long" });

  const formatDate = (date: string | null) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };


  const activityCategoryMap: Record<string, string> = {
    EA: "Engagement Activity",
    ES: "Expert Session",
  };

  const columns = [
    {
      title: "SNo.",
      dataIndex: "Sno",
    },
    {
      title: "Activity",
      dataIndex: "activity_name",
      sorter: (a: Engagement, b: Engagement) => safeSort(a, b, "activity_name"),
    },
    {
      title: "Date",
      dataIndex: "activity_fromdate",
      render: (_: any, record: Engagement) => {
        const fromDate = formatDate(record.activity_fromdate);
        const toDate = formatDate(record.activity_todate);

        return toDate && toDate !== fromDate
          ? `${fromDate} - ${toDate}`
          : fromDate;
      },
      sorter: (a: Engagement, b: Engagement) =>
        new Date(a.activity_fromdate).getTime() -
        new Date(b.activity_fromdate).getTime(),
    },
    {
      title: "Month",
      dataIndex: "activity_fromdate",
      render: getMonth,
      sorter: (a: Engagement, b: Engagement) =>
        new Date(a.activity_fromdate).getTime() -
        new Date(b.activity_fromdate).getTime(),
    },
    {
      title: "Category",
      dataIndex: "activity_category",
      sorter: (a: Engagement, b: Engagement) => {
        const catA = activityCategoryMap[a.activity_category] || a.activity_category;
        const catB = activityCategoryMap[b.activity_category] || b.activity_category;
        return catA.localeCompare(catB);
      },
      render: (value: string) => activityCategoryMap[value] || value,
    }
  ];

  const { data: engagementResponse, loading } = useApi<EngagementMainResponse>(
    "/api/engagement-list",
    {
      method: "POST",
      autoCall: true,
      payload: {
        category: activeTab,
      },
      dependencies: [activeTab],
    }
  );

  const tableData = (engagementResponse?.data || []).map((item, index) => ({
    ...item,
    Sno: index + 1,
  }));

  console.log(tableData);

  return (
    <>
      {/* {loading && <Loader />} */}
      <Loader loading={loading} />
      <div className="page-wrapper" id="engagement-calendar">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Engagement Activities </h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Work & Operations</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Engagement Activities
                  </li>
                </ol>
              </nav>
            </div>
            <div className="head-icons ms-2">
              <CollapseHeader />
            </div>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Engagement Activities</h5>
            </div>

            <div className="card-body">
              <div className="mb-3">
                <div
                  className="d-flex overflow-auto"
                  style={{ whiteSpace: "nowrap" }}
                >
                  {tabs.map((tab) => (
                    <button
                      key={tab.key}
                      className={`btn me-2 mb-2 flex-shrink-`}
                      style={{
                        backgroundColor:
                          activeTab === tab.key ? "#2e3294" : "transparent",
                        color: activeTab === tab.key ? "#ffffff" : "#2e3294",
                        border: "1px solid #2e3294",
                        borderRadius: "15px",
                        fontWeight: "500",
                      }}
                      onClick={() => setActiveTab(tab.key)}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>
              </div>

              <div className="card">
                <Table
                  dataSource={tableData}
                  columns={columns}
                  Selection={false}
                  showSearchInput={true}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="footer d-flex align-items-center justify-content-center bg-white border-top p-3">
          <p className="mb-0"> © {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default EngagementCalender;
